import { createContext, useContext, useEffect, useState } from 'react'
import { Session, User } from '@supabase/supabase-js'
import { supabase } from '@/lib/supabaseClient'

type AuthContextType = {
  user: User | null
  session: Session | null
  loading: boolean
  allowed: boolean
}

const WHITELIST = [
  'rjlstudios1612@gmail.com',
  'Richardkelly1612@hotmail.com',
  'mvxamasa@gmail.com',
  'fracturedghoul@gmail.com',
  'richardkelly@rjlstudios.co.uk',
  'montzu.contact@gmail.com',
  'contato@lrbeats.com.br',
  'frankschemes81@gmail.com',
  'prodlorell@gmail.com',
  'insomniscene@outlook.com',
  'pcarel07@gmail.com',
  'kalismokeofficial@gmail.com',
  'mmazeflora@gmail.com',
  'edanibaba@gmail.com',
  'prodmovway@gmail.com',
  'prodbygramad@gmail.com',
  'jinsworldmusic@gmail.com',
  'kayjuiice@gmail.com',
  'banksbaddiel@gmail.com',
  'gyptxvn@gmail.com',
  'deejaysammydagoat@gmail.com',
  'riker006brown@gmail.com',
  'cudda4l@gmail.com',
  'used2that@gmail.com',
  'prod2cozy@gmail.com',
  'shelovescarlxn@gmail.com',
  'axeelloop@gmail.com',
  'chipbtz@gmail.com',
  'bi2lneverchange@gmail.com',
]

const AuthContext = createContext<AuthContextType>({
  user: null,
  session: null,
  loading: true,
  allowed: false,
})

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [session, setSession] = useState<Session | null>(null)
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)
  const [allowed, setAllowed] = useState(false)

  useEffect(() => {
    const getSession = async () => {
      const { data } = await supabase.auth.getSession()
      const currentSession = data.session
      const currentUser = currentSession?.user ?? null

      setSession(currentSession)
      setUser(currentUser)

      if (currentUser?.email) {
        setAllowed(WHITELIST.includes(currentUser.email))
      } else {
        setAllowed(false)
      }

      setLoading(false)
    }

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        const currentUser = session?.user ?? null
        setSession(session)
        setUser(currentUser)

        if (currentUser?.email) {
          setAllowed(WHITELIST.includes(currentUser.email))
        } else {
          setAllowed(false)
        }
      }
    )

    getSession()

    return () => {
      listener.subscription.unsubscribe()
    }
  }, [])

  return (
    <AuthContext.Provider value={{ session, user, loading, allowed }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
